import _get from 'lodash/get';
import _has from 'lodash/has';
import ObjectID from 'bson-objectid';

import { Banner } from 'commons/models/banner.model';
import { isNil } from 'lodash';
import { LOCATION_IMAGE_RATIO_MAP, UserlistData } from './constants';

export const hydrateFormData = (data: any): Banner => {
	const { ctaValue, ctaType, ctaParamsGameName } = data;
	let params;
	if (!isNil(ctaParamsGameName)) {
		params = {
			gameName: ctaParamsGameName.toLowerCase()
		};
	}

	const hydratedData = {
		...data,
		cta: {
			type: ctaType,
			value: ctaValue,
			params
		}
	};

	if (_has(data, 'id')) {
		delete hydratedData.id;
	}

	if (_has(data, 'ctaValue')) {
		delete hydratedData.ctaValue;
	}

	if (_has(data, 'ctaType')) {
		delete hydratedData.ctaType;
	}

	if (_has(data, 'ctaParamsGameName')) {
		delete hydratedData.ctaParamsGameName;
	}

	return hydratedData;
};

export const dehydrateFormData = (formData: any): { bannerData: Banner; userListData?: UserlistData } => {
	const { uids, location, isClosed } = formData;
	const bannerId = _get(formData, '_id', new ObjectID().toHexString());
	const bannerData = {
		...formData,
		_id: bannerId,
		imageRatio: LOCATION_IMAGE_RATIO_MAP[location]
	};

	delete bannerData.uids;
	delete bannerData.index; // which is formed on frontend

	return { bannerData, userListData: isClosed && uids && { bannerId, uids } };
};
